<template>
  <div class="ncrm-workflow-detail__nodes mt-4">
    <template v-for="(node, idx) in nodes" :key="node.key">
      <v-card
        variant="flat"
        class="ncrm-workflow-detail__node"
        :class="{
          'ncrm-workflow-detail__node--active': node.key === selectedNodeKey,
          [`ncrm-workflow-detail__node--accent-${node.color}`]: true,
        }"
        tabindex="0"
        role="button"
        :aria-pressed="node.key === selectedNodeKey"
        :aria-label="node.label"
        @click="$emit('update:selectedNodeKey', node.key)"
        @keyup.enter="$emit('update:selectedNodeKey', node.key)"
        @keyup.space.prevent="$emit('update:selectedNodeKey', node.key)"
      >
        <span class="ncrm-workflow-detail__node-marker" aria-hidden="true" />
        <div class="ncrm-workflow-detail__node-icon" aria-hidden="true">
          <v-icon size="20" color="white">{{ node.icon }}</v-icon>
        </div>
        <div class="ncrm-workflow-detail__node-body">
          <div class="ncrm-workflow-detail__node-head">
            <div class="ncrm-workflow-detail__node-title">{{ node.label }}</div>
            <v-btn
              icon="mdi-pencil-outline"
              variant="text"
              size="x-small"
              density="comfortable"
              class="ncrm-workflow-detail__node-edit"
              :aria-label="$t('ncrm.workflows.actions.editNode')"
              @click.stop="$emit('edit-node', node)"
            />
          </div>
          <div class="ncrm-workflow-detail__node-description">{{ node.description }}</div>
          <div class="ncrm-workflow-detail__node-chips">
            <v-chip size="x-small" :color="node.color">
              {{ statusLabel(node.statusKey) }}
            </v-chip>
            <v-chip v-if="node.key === apiNodeKey && apiSummary.endpoint" size="x-small" color="neutral">
              {{ apiSummary.endpoint.entity_scope }}
            </v-chip>
            <v-chip v-if="node.key === apiNodeKey && autoSyncSettings.autoSync" size="x-small" color="success">
              <v-icon start size="10">mdi-sync</v-icon>
              {{ autoSyncLabel }}
            </v-chip>
            <v-chip v-if="node.key === duplicateNodeKey && dedupAutoRunSettings.autoRun" size="x-small" color="warning">
              <v-icon start size="10">mdi-sync</v-icon>
              {{ dedupAutoRunLabel }}
            </v-chip>
            <v-chip v-if="node.key === duplicateNodeKey && dedupAutoRunSettings.skipAiVerification" size="x-small" color="warning">
              {{ $t('ncrm.workflows.nodeSettings.dedup.skipAiVerificationChip') }}
            </v-chip>
            <v-chip v-if="node.key === dataEnrichmentNodeKey && enrichmentSettings.mode === 'automatic'" size="x-small" color="info">
              <v-icon start size="10">mdi-auto-fix</v-icon>
              {{ enrichmentAutoLabel }}
            </v-chip>
            <v-chip v-if="node.key === dataEnrichmentNodeKey && enrichmentSettings.promptKey" size="x-small" color="neutral">
              {{ enrichmentSettings.promptKey }}
            </v-chip>
            <v-chip v-if="node.key === crmWriteNodeKey && crmWriteSettings.autoRun" size="x-small" color="success">
              <v-icon start size="10">mdi-sync</v-icon>
              {{ crmWriteAutoRunLabel }}
            </v-chip>
            <v-chip v-if="node.key === leadBoardNodeKey && leadBoardSettings.autoRun" size="x-small" color="success">
              <v-icon start size="10">mdi-sync</v-icon>
              {{ leadBoardAutoRunLabel }}
            </v-chip>
          </div>
        </div>
      </v-card>
      <div v-if="idx < nodes.length - 1" class="ncrm-workflow-detail__connector" aria-hidden="true">
        <span class="ncrm-workflow-detail__connector-line" />
        <v-icon size="14" class="ncrm-workflow-detail__connector-arrow">mdi-chevron-right</v-icon>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: "NcrmWorkflowNodeRail",
  props: {
    nodes: { type: Array, default: () => [] },
    selectedNodeKey: { type: String, default: "" },
    apiNodeKey: { type: String, required: true },
    duplicateNodeKey: { type: String, required: true },
    dataEnrichmentNodeKey: { type: String, required: true },
    crmWriteNodeKey: { type: String, required: true },
    leadBoardNodeKey: { type: String, required: true },
    apiSummary: { type: Object, default: () => ({}) },
    autoSyncSettings: { type: Object, default: () => ({}) },
    dedupAutoRunSettings: { type: Object, default: () => ({}) },
    enrichmentSettings: { type: Object, default: () => ({}) },
    crmWriteSettings: { type: Object, default: () => ({}) },
    leadBoardSettings: { type: Object, default: () => ({}) },
    autoSyncLabel: { type: String, default: "" },
    dedupAutoRunLabel: { type: String, default: "" },
    enrichmentAutoLabel: { type: String, default: "" },
    crmWriteAutoRunLabel: { type: String, default: "" },
    leadBoardAutoRunLabel: { type: String, default: "" },
  },
  emits: ["update:selectedNodeKey", "edit-node"],
  methods: {
    statusLabel(statusKey) {
      return this.$t(`ncrm.workflows.nodeStatus.${statusKey || "planned"}`);
    },
  },
};
</script>

<style src="./NcrmWorkflowDetail.css" scoped></style>
